module.exports = __webpack_public_path__ + "media/images/icons/country_flags/eg-97e2c2ad7636d76b6299d880ca05abc6.svg";